import React from 'react';
import { Image } from 'react-bootstrap';
import {
    APP_STORE_LINK,
    GOOGLE_PLAY_LINK
} from '../constants/constants';

import appStore from '../assets/app-store.png';
import googlePlay from '../assets/google-play.png';

function DownloadLinks({ onClick }) {
    return (
        <span style={{ display: 'inline', textAlign: 'center' }}>
            {/* Download our app:&nbsp;&nbsp;&nbsp;

            <a href={APP_STORE_LINK} target='_blank' aria-label="Download on the App Store" style={{ margin: '0 5px' }}>
                <img src={appStore} alt="App Store" style={{ verticalAlign: 'middle', width: 'auto', height: '40px' }} />
            </a>
            <a href={GOOGLE_PLAY_LINK} target='_blank' aria-label="Get it on Google Play" style={{ margin: '0 5px' }}>
                <img src={googlePlay} alt="Google Play" style={{ verticalAlign: 'middle', width: 'auto', height: '40px' }} />
            </a> */}
            <br /><br />
        </span>

    );
}

export default DownloadLinks;
